<template>
  <a-form-item label="问卷英文名称">
    <a-input v-model="form.enName" />
  </a-form-item>
</template>

<script>
export default {
  props: ['form'],
};
</script>